import { render, staticRenderFns } from "./ProductsRedesignSkeleton.vue?vue&type=template&id=85f92b0c&"
import script from "./ProductsRedesignSkeleton.vue?vue&type=script&lang=js&"
export * from "./ProductsRedesignSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./ProductsRedesignSkeleton.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports